// extracted by mini-css-extract-plugin
export var footerWrapper = "footer-module--footerWrapper--692b5";
export var signupForm = "footer-module--signupForm--011d4";